"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Colors = {
    // RuneScape/Jagex colour pallet
    bluePanel: "#101d23",
    // Set the defaults
    primary: "#E1BB34",
    text: "#ECEDEE",
    background: "#411102",
    heading: "#E1BB34",
    error: "#DA222E",
    blackout: "rgba(0, 0, 0, 0.25)"
};
